import { isEmptyOrWhiteSpace } from './comparators'

/* eslint-disable prefer-const */
export default class Query {
  _name = ''
  _fields = ''
  _args = ''
  _key = ''
  _temp = ''

  constructor (recordName, fields, args, key) {
    this._name = recordName
    this._fields = this._fields.concat(fields)
    this._args = Object.assign(this._args, args)
    this._key = key
    this._temp = fields
  }

  _normalizeArgs (args) {
    const list = []
    for (let [key, value] of Object.entries(args)) {
      if (typeof value === 'object') {
        // eslint-disable-next-line no-useless-escape
        value = JSON.stringify(value).replace(/\"([^(\")"]+)\":/g, '$1:')
      }
      list.push(`${key}: ${value}`)
    }
    return list.join(', ')
  }

  _normalizeFields (fields) {
    let fieldsString = []
    for (let field of fields) {
      if (typeof field === 'string') {
        fieldsString.push(field)
      } else if (typeof field === 'object') {
        const subField = `${field.name} ${this._normalizeFields(field.fields)}`
        fieldsString.push(subField)
      }
    }
    return `{${fieldsString.join(' ')}}`
  }

  get build () {
    const args = this._normalizeArgs(this._args)
    const query = this._key
      ? `${this._key}: ${this._name} ${(!isEmptyOrWhiteSpace(args)) ? `(${args})` : ''} ${this._normalizeFields(this._temp)}`
      : `{${this._name} ${(!isEmptyOrWhiteSpace(args)) ? `(${args})` : ''} ${this._normalizeFields(this._temp)}}`

    return query
  }
}
